<div class="container py-2 my-1 container-datos" *ngIf="configuracionDePago">
  <button
    class="d-block mb-2 container-datos__go-back"
    (click)="goBackProducto()"
  >
    <i class="fas fa-chevron-left mr-1"></i> Regresar
  </button>
  <div class="row">
    <div class="col-12 col-lg-8 d-flex justify-content-center">
      <div class="d-flex justify-content-center align-items-center my-4 timer">
        <i class="far fa-info-circle timer__icon mr-3"></i>
        <label class="m-0">
          Recuerda que tienes<span class="font-weight-bold mx-1"
            ><countdown
              *ngIf="tiempoLimiteExpiracionPago"
              [config]="{
                leftTime: tiempoLimiteExpiracionPago,
                format: 'mm:ss'
              }"
              (event)="handleEventCountDown($event.action)"
            ></countdown></span
          >minutos para realizar tu pago.
        </label>
      </div>
    </div>
    <ng-container
      *ngIf="
        configuracionDePago && resumenDescuentosFacade.resumenDescuentos$
          | async as resumenDescuentos
      "
    >
      <div class="col-12 col-sm-12 col-lg-8 tabset-payments mb-3 mb-md-0">
        <ul ngbNav #nav="ngbNav" class="nav-tabs d-flex">
          <li
            [ngbNavItem]="1"
            class="flex-grow-1"
            *ngIf="
              configuracionDePago.mediosPagoHabilitados.pse ||
              configuracionDePago.mediosPagoHabilitados.exito ||
              configuracionDePago.mediosPagoHabilitados.botonBancolombia ||
              (configuracionDePago.mediosPagoHabilitados.tarjetaCredito &&
                !isProductoSoat)
            "
          >
            <a ngbNavLink class="text-center"
              >PSE y otros medios de pago<i class="fal fa-wallet ml-2"></i
            ></a>
            <ng-template ngbNavContent>
              <app-otro-medio-de-pago
                [configuracionDePago]="configuracionDePago"
                [resumenDescuentos]="resumenDescuentos"
                (handlePagarOtroMedio)="handlePagarOtroMedio()"
                [formularioMedioDePago]="formularioMedioDePago"
                [submitted]="submitted"
              ></app-otro-medio-de-pago>
            </ng-template>
          </li>
        </ul>
        <div [ngbNavOutlet]="nav" class="mt-2"></div>
      </div>
      <div class="col-12 col-sm-12 col-lg-4 mt-5 mt-lg-0">
        <app-resumen-compra
          [configuracionDePago]="configuracionDePago"
          [resumenDescuentos]="resumenDescuentos"
        >
        </app-resumen-compra>
      </div>
    </ng-container>
  </div>
</div>
<app-modal-error
  [error]="pagoFacade.error$ | async"
  (handleSubmitModalError)="clearErrorModal()"
></app-modal-error>

<ng-template #modalGoBack>
  <lib-sura-modal class="modal-go-back">
    <ng-container slot="body">
      <p class="modal-go-back__description mb-4">
        ¡Ten en cuenta que si aceptas regresar al paso anterior, se perderá la
        información que ingresaste!
      </p>
      <div class="d-flex justify-content-around">
        <button class="modal-go-back__button" (click)="ngbModal.dismissAll()">
          Cancelar
        </button>
        <button class="modal-go-back__button" (click)="goBack()">
          Aceptar
        </button>
      </div>
    </ng-container>
  </lib-sura-modal>
</ng-template>
